/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: bd23c504 (Thu Jun 11 17:44:43 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  RegionFeeSetting,
  RegionFeeSettingFromJSON,
  RegionFeeSettingToJSON,
} from './'

/**
 *
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
  /**
   *
   * @type {Array<RegionFeeSetting>}
   * @memberof InlineObject
   */
  regionFees: Array<RegionFeeSetting>
}

export function InlineObjectFromJSON(json: any): InlineObject {
  return InlineObjectFromJSONTyped(json, false)
}

export function InlineObjectFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InlineObject {
  if (json === undefined || json === null) {
    return json
  }
  return {
    regionFees: (json['regionFees'] as Array<any>).map(
      RegionFeeSettingFromJSON
    ),
  }
}

export function InlineObjectToJSON(value?: InlineObject | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    regionFees: (value.regionFees as Array<any>).map(RegionFeeSettingToJSON),
  }
}
